<template>
  <component :is="layoutComponent" v-bind="{ ...props, productHandle }">
    <div class="relative">
      <FullWidthTeaserImage v-if="isImage" :asset="imageOrVideo[0]" />
      <FullWidthTeaserVideo v-if="isVideo" :video-src="videoSrc" />

      <div
        v-if="editorsPick"
        class="absolute top-5 sm:top-10 right-5 sm:right-10 bg-white rounded-full w-28 h-8 text-center font-medium fluid-xs leading-tightest flex items-center justify-center"
      >
        {{ $t('editorsPick') }}
      </div>

      <div
        v-if="fullWidthTeaserLayout === 'primary' && (teaser || !buttonPrimary)"
        class="absolute inset-0 bg-linear-to-t from-black/70 via-black/30 to-transparent"
        role="presentation"
      ></div>
    </div>
  </component>
</template>

<script setup>
import FullWidthTeaserImage from './fragments/FullWidthTeaserImage.vue';
import FullWidthTeaserVideo from './fragments/FullWidthTeaserVideo.vue';
import Primary from './layouts/Primary.vue';
import Boxed from './layouts/Boxed.vue';
import Contained from './layouts/Contained.vue';

const props = defineProps({
  // Content
  mainHeading: {
    type: String,
    default: null,
  },

  heading: {
    type: String,
    default: null,
  },
  headingSize: {
    type: String,
    default: 'default',
    validator: (value) => ['default', 'large'].includes(value),
  },
  teaser: {
    type: String,
    default: null,
  },
  imageOrVideo: {
    type: Array,
    default: () => [],
  },
  tag: {
    type: String,
    default: null,
  },
  cta: {
    type: Array,
    default: () => [],
  },
  secondaryCta: {
    type: Array,
    default: () => [],
  },
  // Layout
  fullWidthTeaserLayout: {
    type: String,
    default: 'primary',
    validator: (value) => ['primary', 'boxed', 'contained'].includes(value),
  },
  buttonPrimary: {
    type: Boolean,
    default: false,
  },
  editorsPick: {
    type: Boolean,
    default: false,
  },
  boxPosition: {
    type: String,
    default: 'topLeft',
    validator: (value) =>
      ['topLeft', 'topRight', 'middleLeft', 'middleRight', 'bottomLeft', 'bottomRight', 'center'].includes(value),
  },
  position: {
    type: Boolean,
    default: false,
  },
  hasScrollingContent: {
    type: Boolean,
    default: false,
  },
  boxOutside: {
    type: Boolean,
    default: false,
  },
});

const layoutComponent = computed(() => {
  switch (props.fullWidthTeaserLayout) {
    case 'primary':
      return Primary;
    case 'boxed':
      return Boxed;
    case 'contained':
      return Contained;
    default:
      return Primary; // Fallback to Primary if no match
  }
});

const isImage = computed(() => {
  return props.imageOrVideo.length && props.imageOrVideo[0] && props.imageOrVideo[0].kind === 'image';
});

const isVideo = computed(() => {
  return props.imageOrVideo.length && props.imageOrVideo[0] && props.imageOrVideo[0].kind === 'video';
});

const videoSrc = computed(() => {
  return isVideo.value ? props.imageOrVideo[0].url : null;
});

const productHandle = computed(() => {
  const elem = props.cta[0]?.element;
  return elem?.sectionHandle === 'products' ? elem.shopifyHandle : null;
});
</script>
